import { parseCurrency, toCents } from 'components/Widget/shared/currency';
import type { CalculatorFieldValues } from 'components/Widget/shared/types';
import { CURRENT_SAVINGS_FIELD, EXPENSE_FIELDS, MONTHLY_CONTRIBUTION_FIELD } from './constants';
import type { EmergencyFundResult, FundGoalKey } from './types';

export const formatMonths = (months: number): string => `${months} ${months === 1 ? 'month' : 'months'}`;

export const calculateEmergencyFund = (values: CalculatorFieldValues, goalKey: FundGoalKey): EmergencyFundResult => {
  const monthlyExpenses = EXPENSE_FIELDS.reduce((total, field) => total + parseCurrency(values[field.label] ?? ''), 0);
  const monthlyContribution = parseCurrency(values[MONTHLY_CONTRIBUTION_FIELD.label] ?? '');
  const alreadySaved = parseCurrency(values[CURRENT_SAVINGS_FIELD.label] ?? '');
  const goal = goalKey * monthlyExpenses;
  const isGoalReached = goal > 0 && alreadySaved >= goal;
  // Savings past the goal leave nothing to save, rather than a negative timeline.
  const remaining = Math.max(0, goal - alreadySaved);
  // Dividing in cents keeps float drift in the dollar figures from tipping the ceiling into an extra month.
  const contributionInCents = toCents(monthlyContribution);
  const hasSavingsTimeline = goal > 0 && contributionInCents > 0;

  return {
    monthlyExpenses,
    monthlyContribution,
    goal,
    // Legacy's Infinity and NaN paths both rendered as `-`; null carries that to the panel.
    monthsToGoal: isGoalReached ? 0 : hasSavingsTimeline ? Math.ceil(toCents(remaining) / contributionInCents) : null,
  };
};
